export class FontFamilies {
  id: string;
  name: string;
  accountTypeId: number;
  isArchived: boolean;
}
